export const CURPChars = Object.freeze({
    SURNAME_A_CHAR : 0,
    SURNAME_A_VOWEL : 1,
    SURNAME_A_CONSONANT : 13,

    SURNAME_B_CHAR : 2,
    SURNAME_B_CONSONANT : 14,

    NAME_CHAR : 3,
    NAME_CONSONANT : 15,

    YEAR_0 : 4,
    YEAR_1 : 5,
    MONTH_0 : 6,
    MONTH_1 : 7,
    DAY_0 : 8,
    DAY_1 : 9,

    SEX : 10,
    REGION_0 : 11,
    REGION_1 : 12,

    HOMONYMY : 16,
    VERIFICATION : 17
});

export const Gender = Object.freeze({
    UNKNOWN : 0,
    MALE: 'H',
    FEMALE: 'M'
})